import { defineMessages } from "react-intl";

export const transactionRefundReasonMessages = defineMessages({
  reasonForRefund: {
    defaultMessage: "Reason for refund",
    id: "991li9",
    description: "input label",
  },
  optionalPlaceholder: {
    defaultMessage: "Optional",
    id: "F8pCg4",
    description: "input placeholder",
  },
});
